import { render } from "./PViewVideos.vue?vue&type=template&id=3daafcba"
import script from "./PViewVideos.vue?vue&type=script&lang=js"
export * from "./PViewVideos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__